
// ────── Web : mock modulaire 100 % compatible avec ton code ──────
const mockCrashlytics = {
  log: async (ref, message) => {
    console.debug('[Crashlytics:mock] log →', message);
    return Promise.resolve();
  },
  recordError: async (ref, error) => {
    console.warn('[Crashlytics:mock] recordError →', error?.message || error);
    return Promise.resolve();
  },
  setUserId: async (ref, userId) => {
    console.debug('[Crashlytics:mock] setUserId →', userId);
    return Promise.resolve();
  },
  setAttributes: async (ref, attributes) => {
    console.debug('[Crashlytics:mock] setAttributes →', attributes);
    return Promise.resolve();
  },
  crash: async (ref) => {
    console.warn('[Crashlytics:mock] crash() appelé – ignoré sur le web');
    // On ne plante pas l’app web
    return Promise.resolve();
  },
};

const crashlyticsRef = {};

export const getCrashlytics = () => {
  console.debug('[Crashlytics:mock] getCrashlytics() appelé');
  return crashlyticsRef;
};

export const log = (ref, message) => mockCrashlytics.log(ref, message);
export const crash = (ref) => mockCrashlytics.crash(ref);
export const setUserId = (ref, userId) => mockCrashlytics.setUserId(ref, userId);
export const recordError = (ref, error) => mockCrashlytics.recordError(ref, error);
export const setAttributes = (ref, attributes) => mockCrashlytics.setAttributes(ref, attributes);

export default {
  getCrashlytics,
  log,
  crash,
  setUserId,
  recordError,
  setAttributes,
};

if (typeof module !== 'undefined') {
  module.exports = {
    getCrashlytics,
    log,
    crash,
    setUserId,
    recordError,
    setAttributes,
    default: { getCrashlytics },
  };
}